import { AuthProviders } from '@/interfaces';
import { actuator, api } from '@prometheus/utils';
import { BuildInfoDTO } from 'src/interfaces/BuildInfo';
import { SettingsDTO } from '@prometheus/types';

export const getModules = () => {
  // return api.get('/modules');
};

export const getInfo = (): Promise<BuildInfoDTO> => {
  return actuator.get('/actuator/info');
};

export const healthCheck: any = () => {
  return actuator.get('/actuator/health');
};

export const getAuthOptions = (): Promise<AuthProviders> =>
  api.get('/auth-providers');

export const getSettings = (): Promise<SettingsDTO> => {
  return api.get('/settings');
};
